import { FormGroup, Validators, FormControl } from '@angular/forms';
import { isNil } from 'lodash';
import { matchesOtherValidator } from '../lib/validators/matches-other-validator';
import * as i0 from "@angular/core";
export class QuestionControlService {
    constructor() { }
    toFormGroup(questions) {
        const group = {};
        const formValidators = [];
        questions.forEach(question => {
            group[question.key] = new FormControl(question.value);
            if (question.required) {
                if (!question.validators) {
                    question.validators = [];
                }
                question.validators.push(Validators.required);
            }
            if (question.validators) {
                group[question.key].setValidators(question.validators);
            }
            // TODO: Refactor into form level validators object
            if (question.matchQuestionKey) {
                formValidators.push(matchesOtherValidator(question.key, question.matchQuestionKey));
            }
        });
        const formGroup = new FormGroup(group);
        if (formValidators.length > 0) {
            formGroup.setValidators(formValidators);
        }
        return new FormGroup(group);
    }
    toFormGroupfromMultiDimensionalArray(questionGroups) {
        const group = {};
        const formValidators = [];
        questionGroups.forEach(questions => {
            questions.forEach(question => {
                if (this.currentForm) {
                    group[question.key] = new FormControl(isNil(this.currentForm.controls[question.key])
                        ? ''
                        : this.currentForm.controls[question.key].value);
                }
                else {
                    group[question.key] = new FormControl(isNil(question.value) ? '' : question.value);
                }
                if (question.required) {
                    if (!question.validators) {
                        question.validators = [];
                    }
                    question.validators.push(Validators.required);
                }
                if (question.validators) {
                    group[question.key].setValidators(question.validators);
                }
                // TODO: Refactor into form level validators object
                if (question.matchQuestionKey) {
                    formValidators.push(matchesOtherValidator(question.key, question.matchQuestionKey));
                }
            });
        });
        const formGroup = new FormGroup(group);
        if (formValidators.length > 0) {
            formGroup.setValidators(formValidators);
        }
        return new FormGroup(group);
    }
}
QuestionControlService.ngInjectableDef = i0.defineInjectable({ factory: function QuestionControlService_Factory() { return new QuestionControlService(); }, token: QuestionControlService, providedIn: "root" });
